import React from "react";
import { Container } from "react-bootstrap";

export function PageTitle({ title, colour }) {
  const titleStyle = {
    color: "transparent",
    WebkitTextStroke: `1.5px ${colour || "#E61E2A"}`,
    display: "inline-block",
    padding: "0.2em 0",
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    fontWeight: 900,
    fontSize: "clamp(2.2rem, 7vw, 3.8rem)",
  };

  return (
    <Container className="pt-3 mb-2">
      <h2 style={titleStyle}>{title}</h2>
    </Container>
  );
}
